import * as React from 'react'

import Meta from '~/components/meta'
import CustomerComplaintsScreen from '~/screens/customer-complaints'
import { flags } from '~/utils/constants'
import getMetaInfo, { GetMetaInfoResult } from '~/utils/get-meta-info'
import redirectTo from '~/utils/redirect-to'

interface CustomerComplaintsPageProps {
  metaInfo: GetMetaInfoResult
}

const CustomerComplaintsPage = (props: CustomerComplaintsPageProps) => {
  const { metaInfo } = props

  return (
    <>
      <Meta {...metaInfo} title="Libro de reclamaciones" />
      <CustomerComplaintsScreen />
    </>
  )
}

CustomerComplaintsPage.standalone = true

CustomerComplaintsPage.getInitialProps = async (context: PageContext): Promise<CustomerComplaintsPageProps | void> => {
  if (!context.hasFlag(flags.CUSTOMER_COMPLAINTS)) {
    return redirectTo('/', context)
  }

  return { metaInfo: getMetaInfo(context) }
}

export default CustomerComplaintsPage
